import ConnectionService, { HttpMethod } from './connection.service';
import { IIssueAnalysis, ILoglytics, LoglyticsStatus } from '../../models/loglytics.model';

export interface ILoglyticsUpdate {
  status?: LoglyticsStatus;
}

class LoglyticsConnection {
  public async get(data: object): Promise<ILoglytics[]> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/loglytics`, HttpMethod.GET, data);
  }

  public async getOne(key: string, data?: object): Promise<ILoglytics> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/loglytics/${key}`, HttpMethod.GET, data);
  }

  public async updateLoglytics(key: string, data: ILoglyticsUpdate): Promise<ILoglytics> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/loglytics/${key}`, HttpMethod.PUT, data);
  }

  public async runAnalysis(key: string, force?: boolean): Promise<IIssueAnalysis | null> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/loglytics/${key}/runAnalysis`, HttpMethod.POST, {force});
  }

  public async createFixPr(key: string): Promise<{prUrl: string}> {
    return await ConnectionService.fetch(`${ConnectionService.appUrl}/loglytics/${key}/createFixPr`, HttpMethod.POST);
  }

}

export default new LoglyticsConnection();
